import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { OPS_HUB_ROUTE_PATHS } from '../config';

export const DEBT_ENGINE_ROUTES: TApplicationRoute[] = [
  {
    id: 'ops-hub-debt-engine',
    path: OPS_HUB_ROUTE_PATHS.debtEngine,
    component: lazy(() => import('./pages/debt-engine-page')),
    layout: 'default',
    permissions: { roles: [], scopes: ['debt-engine'] },
    menu: {
      title: 'Debt Engine',
    },
  },
];
